import { useEffect, useState } from 'react';

/**
 * #659 §UAT-2026-07-08-R659 §R659-2⑤ — 단순 debounce 훅.
 * terminology-management/StandardTermFormDialog 의 기존 `useDebounced` 패턴과 동형.
 * CommandPalette 의 ⑤ 표준용어 서버검색(keyword) 을 300ms debounce 하는 데 사용한다.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
